<template>
  <div class="navMenu">
 
    <label v-for="navMenu in navMenus" :key="navMenu.id">
      <el-menu-item v-if="navMenu.children==null"
                    :key="navMenu.id" :data="navMenu" :index="String(navMenu.id)" 
                    >
        <!-- <i :class="navMenu.entity.icon"></i> -->
        <span slot="title">{{navMenu.label}}</span>
      </el-menu-item>
 
      <el-submenu v-if="navMenu.children"
                  :key="navMenu.id" :data="navMenu" :index="String(navMenu.id)">
        <template slot="title">
          <!-- <i :class="navMenu.entity.icon"></i> -->
          <span> {{navMenu.label}}</span>
        </template>
        <NavMenu :navMenus="navMenu.children"></NavMenu>
      </el-submenu>
    </label>
 
  </div>

</template>
<script>

export default {
    name: 'NavMenu',
    props: ['navMenus'],
    data() {
        return {

        }
    },
}
</script>
<style lang="scss" scoped>
::v-deep .el-menu-item, ::v-deep .el-submenu__title{
  height: auto;
  line-height: 1.5;
  padding:10px 20px;
  white-space: normal;

}
::v-deep .el-menu-item span::before{
    content:"";
    display: inline-block;
    width: 6px;
    height:6px;
    background:#333;
    border-radius: 50%;
    vertical-align: middle;
    margin-right:5px;
}
::v-deep .el-menu-item.is-active span::before{
  background:#0054A7;;
}
</style>